import { render, staticRenderFns } from "./UpdateCardExpiry.vue?vue&type=template&id=5055afa3"
import script from "./UpdateCardExpiry.vue?vue&type=script&lang=js"
export * from "./UpdateCardExpiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports